<template>
  <pop-box
    ref="myPopbox"
    class="upload-popbox"
    :hasNotButton="true"
    :title="title"
    @closeDialog="$emit('close')"
    :width="750"
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
      <el-form-item label="用户名" prop="userName">
        <el-input v-model="formData.userName"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="employeeId">
        <el-select clearable filterable v-model="formData.employeeId" placeholder="请选择" @change="employeeChange">
          <el-option
            v-for="item in employeeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="电话号码" prop="phoneNumber">
        <el-input v-model="formData.phoneNumber"></el-input>
      </el-form-item>
      <el-form-item label="生日">
        <el-date-picker
          v-model="formData.birthday"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="性别">
        <el-radio-group style="margin-left: 8px" v-model="formData.sex">
          <el-radio label="0">男</el-radio>
          <el-radio label="1">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="选择角色" prop="roleId">
        <el-select clearable v-model="formData.roleId" placeholder="请选择">
          <el-option
            v-for="item in roleList"
            :key="item.id"
            :label="item.roleName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否启用">
        <el-switch
          style="margin-left: 8px"
          v-model="formData.isStart"
          active-value="1"
          inactive-value="0"
          active-text="是"
          inactive-text="否"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="重置密码" v-if="mode === 'edit'" prop="pwd">
        <el-input v-model="formData.pwd" show-password></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer btn-wrapper">
      <el-button class="btnx-normal btn-blue" @click="save">保存</el-button>
      <el-button class="btnx-normal btn-gray" @click="onClose">关闭</el-button>
    </div>
  </pop-box>
</template>
<script>
import { getAction } from "@/service/http/api";
import des from "@/service/des";
import editMixin from "@/mixin/editModal";
import formRules from "@/service/formRules"
export default {
  name: "Edit",
  props: ["rowId", "title", "mode"],
  mixins: [editMixin],
  data() {
    return {
      formData: {
        userName: null,
        name: null,
        phoneNumber: null,
        isStart: "1",
        birthday: null,
        sex: "0",
        pwd: "Fanglei@2022",
        strPwd: null,
        roleId: null,
        employeeId: null,
      },
      rules:{
        userName:[ { required: true, message: '请输入用户名', trigger: 'blur' },formRules.userName],
        phoneNumber:[formRules.tel],
        pwd:[formRules.pwd],
        employeeId:[ { required: true, message: '请选择员工', trigger: 'change' }],
        roleId:[ { required: true, message: '请选择角色', trigger: 'change' }],
      },
      roleList: [],
      employeeList: [],
      url: {
        add: "/login/userRegister",
        roleList: "/role/list",
        employeeList:'/employee/employeeInfo/list',
        addRole: "/role/addRoleToUser",
        query: "/login/queryInfoById",
        edit: "/login/edit",
      },
    };
  },
  methods: {
    /**
     * 保存成功后更新用户角色数据
     * @param id
     */
    afterSave(id) {
      getAction(this.url.addRole, { uId: id, rIds: this.formData.roleId }).then(
        (res) => {
          if (res.code === 200) {
            this.$message({
              message: "用户角色设置成功!",
              type: "success",
            });
          }
        }
      );
    },
    init() {
      let val = this.formData.roles[0] ? this.formData.roles[0].id : null;
      this.$set(this.formData, "roleId", val);
    },
    save() {
      //22-02-15 yjs 处理重置密码为空时还是会产生strpwd的情况 start
      if (this.formData.pwd !== undefined && this.formData.pwd !== "") {
        this.formData.strPwd = des.des_encrypt(this.formData.pwd);
      } else {
        this.formData.strPwd = null;
      }
      //22-02-15 yjs 处理重置密码为空时还是会产生strpwd的情况 start
      delete this.formData.pwd;
      this.onSave();
    },
    employeeChange(e){
      let temp = this.employeeList.find(item=>item.id===e);
      this.formData.name = temp.name;
    }
  },
  created() {
    getAction(this.url.roleList, { pageNum: 1, pageSize: 1000 }).then((res) => {
      if (res.code === 200) {
        this.roleList = res.data.records;
        if(this.mode==='new'){
          let temp = this.roleList.find(item=>item.roleName==='普通用户');
          this.formData.roleId = temp.id;
        }
      }
    });
    getAction(this.url.employeeList, { pageIndex: 1, pageSize: 1000 }).then((res) => {
      if (res.code === 200) {
        this.employeeList = res.data.records;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.img-item {
  margin: 20px 40px;
  float: left;
  position: relative;
  width: 300px;
  p {
    line-height: 30px;
    color: #0d74fe;
  }
  .left,
  .right {
    position: absolute;
    top: 0;
    width: 30px;
    height: 300px;
    background: #ffffff;
  }
  .left {
    left: 0;
  }
  .right {
    right: 0;
  }
}
.img-item img {
  width: 240px;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user_management/edit.vue